export default {
  Popconfirm: {
    positiveText: '确认',
    negativeText: '取消',
  },
};
